import { j as o } from "../../../jsx-runtime-BwWtxLpl.js";
import { useContext as d } from "react";
import e from "prop-types";
import h from "classnames";
import { IconoirCheck as F, IconoirMinus as I } from "@ey-xd/motif-icon";
import { MotifIcon as x } from "../../icon/icon.js";
import { IconContext as w } from "../../icon/icon.context.js";
import "../form-field/form-field.js";
import { FormFieldContext as y } from "../form-field/form-field.context.js";
const M = {
  checked: F,
  indeterminate: I
}, p = ({
  checked: c,
  children: b,
  className: k,
  disabled: t,
  icons: a,
  id: r,
  indeterminate: i,
  name: u,
  onChange: C,
  required: l,
  value: N,
  ...j
}) => {
  const m = d(y), { checkbox: f } = d(w);
  let n;
  f ? n = {
    ...f,
    ...a
  } : n = {
    ...M,
    ...a
  };
  let s;
  c ? s = "true" : i ? s = "mixed" : s = "false";
  const g = h({
    "motif-checkbox-wrapper": !0,
    "motif-checkbox-wrapper-disabled": t,
    "motif-checkbox-wrapper-invalid": m.invalid,
    [k]: !0
  }), v = h({
    "motif-checkbox": !0,
    "motif-checkbox-checked": c,
    "motif-checkbox-indeterminate": i,
    "motif-checkbox-disabled": t,
    "motif-checkbox-invalid": m.invalid
  });
  return /* @__PURE__ */ o.jsx("label", { className: g, htmlFor: r, "data-motif-checkbox": !0, children: /* @__PURE__ */ o.jsxs("span", { className: v, children: [
    /* @__PURE__ */ o.jsx(
      "input",
      {
        ...j,
        "aria-checked": s,
        className: "motif-checkbox-input",
        defaultChecked: c,
        disabled: t,
        id: r,
        indeterminate: i ? 1 : 0,
        name: u,
        onChange: C,
        required: l,
        type: "checkbox",
        value: N
      }
    ),
    /* @__PURE__ */ o.jsxs("span", { className: "motif-checkbox-inner", children: [
      c && !i && /* @__PURE__ */ o.jsx(x, { className: "motif-checkbox-icon", iconFunction: n.checked, fill: "none" }),
      !c && i && /* @__PURE__ */ o.jsx(x, { className: "motif-checkbox-icon", iconFunction: n.indeterminate, fill: "none" })
    ] }),
    /* @__PURE__ */ o.jsxs("span", { className: "motif-checkbox-label", children: [
      b,
      " ",
      l && " (required)"
    ] })
  ] }) });
};
p.propTypes = {
  /**
   * Whether the checkbox is checked.
   */
  checked: e.bool,
  /**
   * The content of the checkbox.
   */
  children: e.node,
  /**
   * Custom CSS classes to be added to the checkbox.
   */
  className: e.string,
  /**
   * Whether the checkbox is disabled.
   */
  disabled: e.bool,
  /**
   * Custom icons to be used for the checkbox.
   */
  icons: e.shape({
    checked: e.node,
    indeterminate: e.node
  }),
  /**
   * The id of the checkbox.
   */
  id: e.string,
  /**
   * Whether the checkbox is indeterminate.
   */
  indeterminate: e.bool,
  /**
   * The name of the checkbox.
   */
  name: e.string,
  /**
   * Callback fired when the state is changed.
   */
  onChange: e.func,
  /**
   * Whether the checkbox is required.
   */
  required: e.bool,
  /**
   * The value of the checkbox.
   */
  value: e.string
};
p.defaultProps = {
  checked: !1,
  children: null,
  className: "",
  disabled: !1,
  icons: {},
  id: "",
  indeterminate: !1,
  name: "",
  onChange: null,
  required: !1,
  value: ""
};
export {
  p as MotifCheckbox
};
